import { Box } from '@mui/material';
import { PTypography } from '@/components/atoms/Typography/PTypography';

type Props = {
  keyCombo: string;
  description: string;
};

export function GlobalSearchFooterItem({ keyCombo, description }: Props) {
  return (
    <Box display="flex" alignItems="center">
      <PTypography variant={'caption'} sx={{ display: 'inline-block' }}>
        {keyCombo}
      </PTypography>
      <PTypography variant={'caption'} sx={{ ml: 0.5 }}>
        : {description}
      </PTypography>
    </Box>
  );
}
